module.exports = __webpack_public_path__ + "static/media/3af6a6e5841f94afa97ede2a8bf8e343.3277dfc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/3af6a6e5841f94afa97ede2a8bf8e343.jpg
// module id = 260
// module chunks = 0